/**
 * MobileOnlyGuard - Shows content only on mobile devices
 * On desktop, displays a message directing users to their phone
 */

import { Smartphone } from 'lucide-react'

export function MobileOnlyGuard({ children }) {
  return (
    <>
      {/* Mobile content - shown below 768px */}
      <div className="md:hidden h-full">
        {children}
      </div>

      {/* Desktop message - shown at 768px and above */}
      <div className="hidden md:flex flex-col items-center justify-center h-full min-h-[60vh] text-center px-8">
        <div className="bg-gray-50 rounded-2xl p-12 max-w-md">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Smartphone className="w-10 h-10 text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            Open on your phone
          </h2>
          <p className="text-gray-500 leading-relaxed">
            The delivery view is designed for mobile use while you&apos;re out making deliveries.
            Open Odin on your phone to manage your delivery run.
          </p>
        </div>
      </div>
    </>
  )
}

export default MobileOnlyGuard
